import { FilterResponseType } from 'src/providers/filtersAPI/types';

import { METHODS, requestV3 } from '../axiosInstances';

export default {
  get: <T>({ ...params } = {}) => requestV3<T>(METHODS.GET, `/analytics/claims/`, { params }),
  options: (params = {}) =>
    requestV3<FilterResponseType>(METHODS.GET, `/analytics/options/`, { params }),
};
